import { useQuery } from '@tanstack/react-query';
import { analyticsInterceptorV2 } from '../utils/Axios/analyticsInterceptorv2';

// All impact endpoints read one report rebuilt at most every 15 minutes.
const CACHE_MS = 900 * 1000;

// path is relative to /analytics/api, e.g. '/impact/summary'.
const useImpactReport = (path, enabled = true) => {
  const query = useQuery(
    ['impact-report', path],
    async () => {
      const response = await analyticsInterceptorV2.get(path);
      return response.data;
    },
    {
      enabled: Boolean(path) && enabled,
      staleTime: CACHE_MS,
      cacheTime: CACHE_MS,
      refetchOnWindowFocus: false,
      // 4xx (bad year, unknown cohort, not an admin) will not fix itself.
      retry: (failureCount, error) =>
        (error?.response?.status ?? 500) >= 500 && failureCount < 1,
    }
  );

  return { ...query, errorStatus: query.error?.response?.status };
};

export default useImpactReport;
